// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5245":"7efcd805","6693":"7efcd805"}[chunkId] + ".chunk.css";
};